var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.184,
    height: 15.067,
    viewBox: "0 0 13.184 15.067",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M103.533,3.767A3.767,3.767,0,1,1,99.767,0,3.767,3.767,0,0,1,103.533,3.767Z",
    transform: "translate(-93.175)",
    fill: "#888",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M9.229,288H8.737a5.123,5.123,0,0,1-4.291,0H3.955A3.956,3.956,0,0,0,0,291.954v1.225a1.413,1.413,0,0,0,1.413,1.413H11.771a1.413,1.413,0,0,0,1.413-1.413v-1.224A3.956,3.956,0,0,0,9.229,288Z",
    transform: "translate(0 -279.525)",
    fill: "#0d47a1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.1.23d239541e15c6bb3240a01c604461c0.svg";